"use client";

import { useMutation } from "@tanstack/react-query";
import type { ThoughtGrouping, SelectedProfileInput } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { generateResume } from "../api/generateResume";

interface GenerateResumeInput {
  groupingType: ThoughtGrouping;
  selectedProfile: SelectedProfileInput;
  userRequestedLinkMoveOn: boolean;
}

export default function useGenerateResumeMutation() {
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: ({
      groupingType,
      selectedProfile,
      userRequestedLinkMoveOn,
    }: GenerateResumeInput) =>
      generateResume({
        accessToken,
        groupingType,
        selectedProfile,
        userRequestedLinkMoveOn,
      }),
  });
}
